import { render } from "./SearchLatestList.vue?vue&type=template&id=57e36cd2&scoped=true&ts=true"
import script from "./SearchLatestList.vue?vue&type=script&lang=ts"
export * from "./SearchLatestList.vue?vue&type=script&lang=ts"

import "./SearchLatestList.vue?vue&type=style&index=0&id=57e36cd2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e36cd2"]])

export default __exports__